import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../constants/api.js";
import icon from "../../constants/icon.js";
import "./home.css";

import Banners from "../../componentes/banners/banners.jsx";
import Carrossel from "../../componentes/carrossel/carrossel.jsx";
import Colunistas from "../../componentes/colunistas/colunistas.jsx";

function Home() {
  const navigate = useNavigate();

  const [posts, setPosts] = useState([]);
  const [banners, setBanners] = useState([]);
  const [video, setVideo] = useState(null);
  const [colunistas, setColunistas] = useState([]);
  const [materias, setMaterias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);


  useEffect(() => {
    async function carregarDados() {
      try {
        setLoading(true);

        const [
          postsRes,
          bannersRes,
          videoRes,
          colunistasRes,
          materiasRes,
        ] = await Promise.all([
          api.get("/posts"),
          api.get("/banners"),
          api.get("/videos/ativo"), // 🔥 vídeo da home
          api.get("/colunistas"),
          api.get("/materias"),
        ]);

        setPosts(postsRes?.data || []);
        setBanners(bannersRes?.data || []);
        setVideo(videoRes?.data || null);
        setColunistas(colunistasRes?.data || []);
        setMaterias(materiasRes?.data || []);
      } catch (error) {
        console.error("Erro ao carregar dados da home:", error);
      } finally {
        setLoading(false);
      }
    }

    carregarDados();
  }, []);

  if (loading) {
    return <p>Carregando conteúdo...</p>;
  }

  return (
<div className="home">
      {/* HEADER */}
      {/* HEADER */}
  <div className="header-home">
    {/* OVERLAY */}
            <div
              className={`sidebar-overlay ${menuOpen ? "show" : ""}`}
              onClick={() => setMenuOpen(false)}
            ></div>

              {/* MENU LATERAL */}
              {/* MENU LATERAL */}
              <aside className={`sidebar ${menuOpen ? "open" : ""}`}>
                <div className="sidebar-header">
                  <span>Menu</span>
                  <button onClick={() => setMenuOpen(false)}>✕</button>
                </div>

                <nav className="sidebar-nav">
                  
                  <span onClick={() => { navigate("/quem-somos"); setMenuOpen(false); }}>
                    O Rufado
                  </span>

                  <span onClick={() => { navigate("/posts"); setMenuOpen(false); }}>
                    Posts
                  </span>

                  
                    <span onClick={() => {navigate("/materias");setMenuOpen(false);}}>
                        Matérias
                    </span>

                  

                  <span onClick={() => { navigate("/videos"); setMenuOpen(false); }}>
                    Vídeos
                  </span>

                  {/* CONTATOS */}
                  <div className="sidebar-contatos">
                    <strong>Contatos</strong>
                    <span>rufadoempresa@gmail.com</span>
                    <span>(98) 99205-7941</span>
                    <span>(98) 99984-6574</span>
                  </div>
                </nav>
              </aside>


            <div className="header-left">
              <i
                className="bi bi-list"
                onClick={() => setMenuOpen(true)}
              ></i>
            </div>

    <h1>O RUFADO</h1>
    <img src={icon.tambor} alt="Tambor" />

    <div className="header-right">
        <a
          href="https://www.instagram.com/orufado?igsh=aGc5cnZ1NHFjMWxl&utm_source=qr"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <i className="bi bi-instagram"></i>
        </a>

        <a
          href="https://www.youtube.com/channel/UCRw5GS8m6aHIkByZj4b7TLw"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube"
        >
          <i className="bi bi-youtube"></i>
        </a>
    </div>
  </div>


        {/* BANNER RETANGULAR */}
        <Banners banners={banners} tipo="retangulo" />

        {/* CARROSSEL */}
        <Carrossel
            items={posts}
            onClickItem={(post) => navigate(`/posts/${post.id_post}`)}
          />


  <div className="btn-ver">
          <button onClick={() => navigate("/posts")}>Ver Mais</button>
  </div>

    {/* MIDIA */}
  <div className="Container-midia">
          <div className="midia">
            {/* VÍDEO DA HOME */}
            <div className="videos-todos">
              <div className="video">
                {video?.video_url && (
                  <video
                    src={video.video_url}
                    poster={video.capa_video} // ✅ capa do vídeo
                    controls
                    className="video-home"
                  >
                    Seu navegador não suporta vídeo.
                  </video>
                )}
              </div>

              <div className="btn-ver-videos">
                <button onClick={() => navigate("/videos")}>
                  Mais Vídeos
                </button>
              </div>
            </div>

            {/* BANNER QUADRADO */}
            <Banners banners={banners} tipo="quadrado" />
          </div>
        </div>

        {/* COLUNISTAS */}
        <Colunistas colunistas={colunistas} />

        {/* MATÉRIAS */}
        <div id="materias" className="container-materias">
          {materias
              .filter(m => m?.imagem_url)
              .slice(0, 5)
              .map((m, index) => (
                <div
                  key={m.id_materia}
                  onClick={() => navigate(`/materias/${m.id_materia}`)}
                  className={`materia ${index % 2 === 0 ? "left" : "right"}`}
                >
                  <div className="materia-texto">
                    <h2>{m.titulo}</h2>
                    <p>{m.subtitulo}</p>
                  </div>

                  <div className="img-materia">
                    <img
                      src={m.imagem_url}
                      alt={m.titulo}
                      className="materia-img"
                    />
                  </div>
                </div>
          ))}

        </div>

    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <h3>O Rufado</h3>
          <p>Comunicação, projetos sociais e boas notícias.</p>
        </div>

        <div className="footer-contatos">
          <strong>Contatos</strong>
          <span>rufadoempresa@gmail.com</span>
          <span>(98) 99205-7941</span>
          <span>(98) 99984-6574</span>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© 2026 O Rufado. Todos os direitos reservados.</span>
      </div>
    </footer>


        </div>
  );
}

export default Home;
